import { useState, useEffect } from 'react';
import './EmbedSection.css';

const EmbedSection = () => {
  const [embeds, setEmbeds] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [height, setHeight] = useState(450);
  const [width, setWidth] = useState(100);

  useEffect(() => {
    const fetchEmbeds = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/embeds`);
        const data = await res.json();
        const homepage = data.filter(e => e.showOnHomepage && e.isActive);
        setEmbeds(homepage);
      } catch { setEmbeds([]); }
    };
    const fetchSettings = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/settings`);
        const data = await res.json();
        if (data?.embedSettings) {
          setWidth(data.embedSettings.width || 100);
          setHeight(data.embedSettings.height || 450);
        }
      } catch {}
    };
    fetchEmbeds();
    fetchSettings();
  }, []);

  if (embeds.length === 0) return null;

  // iframe kodundan tam ekran butonunu ve gereksiz attribute'ları temizle
  const cleanEmbedCode = (code) => {
    return code
      .replace(/allowfullscreen/gi, '')
      .replace(/webkitallowfullscreen/gi, '')
      .replace(/mozallowfullscreen/gi, '')
      .replace(/height="[^"]*"/gi, `height="${height}"`)
      .replace(/height='[^']*'/gi, `height='${height}'`)
      .replace(/style="[^"]*height[^"]*"/gi, (match) => match.replace(/height:\s*\d+px/gi, `height: ${height}px`));
  };

  return (
    <div className="embed-section">
      {/* Tablar */}
      <div className="embed-tabs">
        {embeds.map((embed, i) => (
          <button
            key={embed._id}
            className={`embed-tab ${activeIndex === i ? 'active' : ''}`}
            onClick={() => setActiveIndex(i)}
            title={embed.title}
          >
            {i + 1}
            <span className="embed-tab-title">{embed.title}</span>
          </button>
        ))}
      </div>

      {/* İçerik */}
      <div className="embed-wrapper" style={{ width: `${width}%`, margin: '0 auto' }}>
        <div className="embed-content" style={{ height: `${height}px` }}>
          <div
            className="embed-content-inner"
            style={{ height: '100%' }}
            dangerouslySetInnerHTML={{ __html: cleanEmbedCode(embeds[activeIndex]?.embedCode || '') }}
          />
        </div>

        {/* Ayar Çubuğu */}
        <div className="embed-controls">
          <label>
            Yükseklik:
            <input type="range" min="200" max="800" value={height} onChange={(e) => setHeight(parseInt(e.target.value))} />
            <span>{height}px</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default EmbedSection;
